import confetti from 'canvas-confetti';
import React, { useEffect, useRef } from 'react';

import { StyledCanvas } from './ConfettiCanvas.styles';

type ConfettiCanvasProps = {
  trigger: boolean;
  options?: confetti.Options;
};

export const ConfettiCanvas: React.FC<ConfettiCanvasProps> = ({ trigger, options }) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    if (!trigger || !canvasRef.current) return;

    const myConfetti = confetti.create(canvasRef.current, {
      resize: true,
      useWorker: true
    });

    myConfetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      ...options
    });
  }, [trigger, options]);

  return <StyledCanvas ref={canvasRef} />;
};
